const SITE_ROOM_V2_PREFIX = 'v2:site:';

export function getSiteRoomV2(siteId) {
  if (siteId == null) return siteId;

  const room = String(siteId);
  return room.startsWith(SITE_ROOM_V2_PREFIX) ? room : `${SITE_ROOM_V2_PREFIX}${room}`;
}

export function isSiteRoomV2(room) {
  return room != null && String(room).startsWith(SITE_ROOM_V2_PREFIX);
}

/** Match the server's targeted room_joined confirmation to one site stream. */
export function isSiteRoomJoinConfirmation(confirmation, siteId) {
  return confirmation != null && confirmation.room === getSiteRoomV2(siteId);
}
